import moment from 'moment';

import { DateFormat } from '@/enums/dateFormat.enum';
import { EVENT_COLOR } from '@/utils/constants';
import { toClock } from '@/utils/time';

/**
 * Przygotowuje eventy do wyświetlenia w FullCalendar
 *
 * @export
 * @param {any[]} events
 * @returns
 */
export function eventsTranslate(events: any[], backgroundColor: string = EVENT_COLOR) {
  return events.map(event => {
    event.date = new Date(event.date);
    event.date.setHours(event.schedule.hour, event.schedule.minute);
    const allDay = event.schedule.duration === 1440 ? true : false;

    return {
      start: event.date,
      end: moment(event.date)
        .add(event.schedule.duration, 'm')
        .toDate(),
      title: event.schedule.name,
      textColor: 'white',
      eventContainerId: event.container.id,
      eventDate: event.date,
      eventHour: event.schedule.hour,
      eventMinute: event.schedule.minute,
      eventTitle: event.schedule.name,
      backgroundColor,
      allDay
    };
  });
}

/**
 * Formatuje daty i zwraca tytuł modala
 *
 * @export
 * @param {Date} date
 * @param {number} hour
 * @param {number} minute
 * @param {string} title
 * @returns
 */
export function formatTitle(date: Date, hour: number, minute: number, title: string) {
  return `${moment(date).format(DateFormat.DATE)} ${toClock(hour)}:${toClock(minute)} ${title}`;
}
